module.exports = __webpack_public_path__ + "static/media/included-penguin.816ce7ac.svg";